<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15">
        <g fill="none" fill-rule="evenodd">
            <g fill="#FFF" fill-rule="nonzero">
                <path d="M11.724 10.327h-.48v-.48a.46.46 0 0 0-.917 0v.939c0 .253.205.459.459.459h.939a.46.46 0 0 0 0-.918z"/>
                <path d="M12.184 6.81V3.735h2.357a.46.46 0 0 0 .459-.46A3.28 3.28 0 0 0 11.724 0H3.276A3.28 3.28 0 0 0 0 3.276V14.54c0 .253.206.459.46.459h10.326A4.22 4.22 0 0 0 15 10.786a4.221 4.221 0 0 0-2.816-3.976zm0-5.847c.932.185 1.668.921 1.853 1.853h-1.853V.963zM.918 14.082V3.276A2.36 2.36 0 0 1 3.276.918h7.99V6.6a4.213 4.213 0 0 0-3.985 1.85H3.275a.46.46 0 0 0 0 .918h3.541a4.195 4.195 0 0 0-.218 1.898H3.276a.46.46 0 0 0 0 .919H6.81c.266.753.74 1.409 1.353 1.898H.918zm9.868 0a3.3 3.3 0 0 1-3.296-3.296 3.3 3.3 0 0 1 3.296-3.296 3.3 3.3 0 0 1 3.296 3.296 3.3 3.3 0 0 1-3.296 3.296z"/>
                <path d="M8.908 2.816H3.276a.46.46 0 0 0 0 .919h5.632a.46.46 0 0 0 0-.919zM8.908 5.633H3.276a.46.46 0 0 0 0 .918h5.632a.46.46 0 0 0 0-.918z"/>
            </g>
        </g>
    </svg>
</template>

<script>
    export default {
        name: "WaitListIcon"
    }
</script>

<style scoped>

</style>
